import { Injectable } from "@angular/core";
import _ from "lodash";
import { BehaviorSubject } from "rxjs";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgard } from "~app/features/planera/model/IAtgard";
import { ArbetsorderInfoAnteckningSelection, IAnteckning } from "./arbetsorder-info-anteckningar.model";
@Injectable({
    providedIn: "root"
})
export class ArbetsorderInfoAnteckningarService {

    selectionChanged = new BehaviorSubject<ArbetsorderInfoAnteckningSelection>(new ArbetsorderInfoAnteckningSelection());
    activeView: "Atgard" | "Arbetsorder";

    private arbetsorder: IArbetsorderDetail;
    private selectedAtgard: IAtgard;
    private arbetsorderAnteckningar: IAnteckning[];

    initSettings(ao: IArbetsorderDetail) {
        this.arbetsorder = ao;
        this.initArbetsorderanteckningar();
        this.selectionChanged.next({
            arbetsorder: ao,
            atgard: this.selectedAtgard,
            arbetsorderAnteckningar: this.arbetsorderAnteckningar
        });
    }

    setAnteckningView(view: "Atgard" | "Arbetsorder", item: IAtgard | IArbetsorderDetail) {
        this.activeView = view;
        if (view === "Atgard") {
            this.selectedAtgard = item as IAtgard;
        } else {
            this.selectedAtgard = null;
        }
        this.selectionChanged.next({
            arbetsorder: this.arbetsorder,
            atgard: this.selectedAtgard,
            arbetsorderAnteckningar: this.arbetsorderAnteckningar
        });
    }

    getAnteckningarCountPresentationBySelectedItem(): string {
        const count = this.getAnteckningarCountBySelectedItem();
        if (count > 0) {
            return `(${count})`;
        }
        return "";
    }

    getArbetsorderAnteckningar(): IAnteckning[] {
        return this.arbetsorderAnteckningar;
    }

    private getAnteckningarCountBySelectedItem(): number {
        let notesCount = 0;
        if (this.activeView === "Arbetsorder") {
            notesCount += this.arbetsorderAnteckningar?.length > 0 ? this.arbetsorderAnteckningar.length : 0;
            notesCount += this.arbetsorder?.anteckningProduktionsplanering?.length > 0 ? 1 : 0;
            notesCount += this.arbetsorder?.anteckningVirkesorder?.length > 0 ? 1 : 0;
        } else if (this.activeView === "Atgard") {
            notesCount += this.selectedAtgard?.uttagsanvisning?.length > 0 ? 1 : 0;
            notesCount += this.selectedAtgard?.anteckningProduktionsplanering?.length > 0 ? 1 : 0;
        }
        return notesCount;
    }

    private readonly initArbetsorderanteckningar = () => {
        this.arbetsorderAnteckningar = [];

        if (!this.arbetsorder.isLeveransvirke && this.arbetsorder.kontraktsanteckningAvverkningsdirektiv) {
            this.addAnteckning({
                anteckning: this.arbetsorder.kontraktsanteckningAvverkningsdirektiv,
                atgarder: [],
                typ: "Anteckning från virkesköp till avverkningsdirektiv och maskinens apteringsfiler"
            });
        }

        this.addGroupedAtgardsAnteckningarToList(atg => atg.grupperingsforslagAnteckning, "Grupperingsanteckning");
        this.addGroupedAtgardsAnteckningarToList(atg => atg.uttagsanvisning, "Uttagsanvisning");
    };

    // Grupperar åtgärder baserat på om deras anteckning är identiska
    // 1. Filtret används för att filtrera fram åtgärder som har satta värden för den egenskapen
    // 2. Filtret används för att gruppera åtgärderna baserat på den egenskapen
    // 3. Grupperingsvärdena mappas in till IAnteckning-objekt
    // 4. Lägg in alla IAntecknings-objekt i listan
    private readonly addGroupedAtgardsAnteckningarToList = (filterGroup: (atg: IAtgard) => string, typ: string) => {
        const groupedNotes = _(this.arbetsorder.atgarder.filter(filterGroup))
            .groupBy(filterGroup)
            .map((value, key) => ({
                anteckning: key,
                atgarder: value,
                typ: typ
            }))
            .value();

        groupedNotes.forEach(ant => this.addAnteckning(ant));
    };

    private addAnteckning(ant: IAnteckning) {
        this.arbetsorderAnteckningar.push(ant);
    }
}
